import React from 'react';
import Routes from "./routes";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../src/assets/scss/styles.scss';

const App = () => <Routes />;

export default App;
